export const bankTypes = {
  GET_ALL_BANKS_SUCCESS: 'GET_ALL_BANKS_SUCCESS',

  GET_MY_BANKS_SUCCESS: 'GET_MY_BANKS_SUCCESS',

  DELETE_BANK_REQUEST: 'DELETE_BANK_REQUEST',
  // DELETE_BANK_LOADING: 'DELETE_BANK_LOADING',
  DELETE_BANK_REQUEST_SUCCESS: 'DELETE_BANK_REQUEST_SUCCESS',
  DELETE_BANK_REQUEST_ERROR: 'DELETE_BANK_REQUEST_ERROR',

  VERIFY_BANK_ACCOUNT_SUCCESS: 'VERIFY_BANK_ACCOUNT_SUCCESS',
  BANK_SETTINGS_SUCCESS: 'BANK_SETTINGS_SUCCESS',
}
